module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001",
      "role": "doc-chapter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "role": "doc-pagebreak",
      "title": "25"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chap_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "chap1",
      "src": "images/chap1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "let"
  }, [_c('b', [_vm._v("D")])]), _vm._v("ad, why are there tanks on the TV? And why did that man have his knee on the neck of that other man?” These words came from the lips of my nine-year-old son, a little more than a month into the US Covid-19 pandemic. As the world sat at home in isolation, many watched in horror as news outlets replayed the death of George Floyd. Eight minutes and forty-six seconds was all it took for his life to be snuffed out, his body lying motionless on a Minneapolis street. Pictures of Floyd’s lifeless Black body circulated around digital media, causing many to speak out against racial injustice and the violence against Black people. The public’s reaction was strong.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Crowds of protesters in Atlanta and around the country and world poured into the streets to mourn this loss and to stand against oppression. Companies and sports leagues that had remained silent on this topic for years sprang into action. Civic leaders demanded change.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "role": "doc-pagebreak",
      "title": "26"
    }
  }, [_vm._v("For others, this nationwide response generated fear, causing some politicians to take aggressive action. Tanks, SWAT teams, and police officers in body armor were called in to “keep the peace.”")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As my wife, Cecilia, and I watched in shock and silence as the events unfolded on our basement TV, Terence II, or TJ as we like to call him, poked his head around the corner to see what was going on. Usually, whenever this happened, his curiosity would subside the moment he saw whatever “boring events” his mom and dad found interesting. We were still in quarantine because of strict Covid-19 protocols, and our children were at home with us most days.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This day was different. The images on the screen gripped his attention, and his tender heart could make little sense of what he saw. He heard the audio of Floyd calling out for his mother just seconds before his death, and it left him with all sorts of questions—questions I felt no parent should ever have to answer. I’m sure it resonated with his nine-year-old brain because he had called out for his mom numerous times as a child.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What happened next was a scene that played out in many Black households that day. I sat my son down to give him “the Talk.” Not the “birds and bees” one, but the conversation most Black parents have with their children, the Talk that is foreign to White households in America, when Black parents painstakingly explain that the innocent world in which our children are raised is not all it seems.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In fact, the Talk I gave him later became a TEDx talk"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-013",
      "id": "ap_ntf-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" on how to talk to Black children in a world of racial injustice. As Black adults, we know that the Talk warns Black children that there are people out there who dislike them simply because of the color of their skin. It was the Talk my mom gave me and that her parents gave her.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This conversation included the following nuggets of wisdom:")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "role": "doc-pagebreak",
      "title": "27"
    }
  }, [_vm._v("“Never walk alone in a store.”")])])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Always keep your hands out of your pockets when you walk into a store.”")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“If you don’t have money, do not even go into a store.”")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“If people are watching you while you are shopping, pull your money out of your pocket and make it visible.”")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“When you drive and get pulled over, keep your hands on the wheel.”")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do not wear baggy clothes, and keep your hair cut short.”")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Because you are a young Black man, you already have two strikes against you.”")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Never pick up anything if you don’t intend to buy it.”")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Never look angry or sad in public because you could be viewed as a threat.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The first time I heard my mom share some of these examples, it seemed like I was drinking out of a firehose. There was so much to process, and it felt like my secure little world had been shattered. When I raised my two children, I took a slightly different approach, although the reality is that I know my wife and I can only do so much to prepare them for a world that might mistreat them because they are Black. Even before they could speak,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-014",
      "id": "ap_ntf-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" I would pull TJ and his sister, Zion, into my bedroom every morning and affirm their identity. I made sure they knew their worth, their value, how much potential they had, and the long legacy of our Black heritage. I told them they were leaders while also validating their joy and bolstering their confidence. I did this because I knew what it was like to grow up as a Black child and have racism thrown in my face long before I knew it had a name through the images I saw on television. I saw how Black people were treated when encountering whiteness.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "role": "doc-pagebreak",
      "title": "28"
    }
  }, [_vm._v("I talked to my children with a deep sense of joy as well as sorrow and humiliation, grieving that any parent should have these conversations with their little ones. But it was this foundation that paved the way for the conversation I had with my son that afternoon, one in which I shared with TJ many of the guidelines my mom had shared with me. We talked about what it means to be a Black man in our culture today and about some of the special challenges he would face as he grew up in a racist society. Honestly, it is one of the hardest conversations I have ever had with my son.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("After our conversation, my son asked if we could do our own form of peaceful protest at home for George Floyd. Together, we got some markers and pieces of cardboard, and I asked him what he wanted to write. Recalling Floyd’s dying words to his mother, TJ took out a marker and wrote, “I am a Black son.” Following his lead, I wrote my own sign, “I am a Black dad.” I cried a lot after this experience because I knew that regardless of how my son and I showed up to protest, it would not erase the past, bring back George Floyd, or take away the disdain and racial bias that some people have against Black people. However, I did it with pride because I was teaching my son that his worth has nothing to do with how we are treated collectively by whiteness. It was a conversation that I refused to hide or bury.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Our talk was a stark reminder for me that White supremacy and the racism of previous generations continue to leave their mark today, and those who seek to ignore it preserve a part of history that comes out through the unchecked beliefs and behaviors of people who harbor this type of hatred. Anderson, Caughy, and Owen write:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The Talk” refers to a specific type of racial socialization message that many Black parents have with their children about how to safely conduct themselves when interacting "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "role": "doc-pagebreak",
      "title": "29"
    }
  }, [_vm._v("with police officers and other individuals in positions of power. With the recent increased exposure of racialized violence against Black people at the hands of police and vigilantes in the United States, many parents of young Black children now feel especially compelled to initiate these conversations to equip their children with the necessary knowledge to protect themselves when interacting with police officers. Black parents bear the unjust burden of striking a balance between alerting their children of possible harm while also not villainizing every member of law enforcement their child may encounter."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-015",
      "id": "ap_ntf-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_vm._v("A HISTORY I WAS NEVER TAUGHT")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I was given the same talk I gave my son, but I did not learn about the depths of Black history until I was out of high school, and I wanted to ensure that my son didn’t have that experience. Imagine growing up and going through your K–12 experience only covering topics that spoke casually to your identity as a Black child, and then once you get out of high school being immersed in a world where the opportunities to learn about your background, heritage, and history are slim to none. You may experience mistreatment due to being Black, but understanding the depths of the structural and systemic history and its implications is a challenge when you are not given a chance to learn these things in school. A recent example of this is when Texas education officials proposed to rename “slavery” to “involuntary relocation,” which was eventually struck down for attempting to downplay the effects of enslavement."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-016",
      "id": "ap_ntf-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Over time I have learned how intentional this was from my education, and many others’. LaGarrett King, a distinguished professor, traces the depiction and intentional removal of Black history from history books in the K–12 experience. He examines literature from 1890 to 1940, the long history of how "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "role": "doc-pagebreak",
      "title": "30"
    }
  }, [_vm._v("Black people were depicted in schoolbooks, and how it was all driven by whiteness and dominated by White males. He writes,")])]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("K–12 social studies textbooks [were] written by White historians and educators who used history as a means to explore ideas of U.S. citizenship. It was common in these textbooks to underscore Black persons as inferior and second-class citizens. Early social studies textbooks emphasized that the “Black skin was a curse” (Woodson, 1933 p. 3) through narratives that purported that Black people were naturally “barbarians,” “destitute of intelligence,” or “having little humanity” (Brown, 2010; Elson, 1964; Foster, 1999).")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He goes on to say that the racialization of blackness was used as a justification for the paternalistic attitudes White citizens had toward Black people."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-017",
      "id": "ap_ntf-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" The erasure of history from schoolbooks took place as a way of keeping Black history away from Black people who might have an opportunity to truly know themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Those in power have often downplayed the role of the enslavement of Africans in the formation of this country’s economy to silence those who see and feel the link between enslavement and today’s racial struggles. MLK notes:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For many African-American educators, early conceptions of social studies educations did not achieve this and [were] disconnected from the political, cultural, or economic realities of the race. For example, numerous White educators believed that Western epistemologies, through the social studies, would help serve as the conduits for the cultural and intellectual development of African Americans."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-018",
      "id": "ap_ntf-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Slavery has been described as a peculiar institution, a regional issue relegated to pockets of the antebellum South and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "role": "doc-pagebreak",
      "title": "31"
    }
  }, [_vm._v("limited in its national economic effects. But this description is false. In Edward E. Baptist’s historical masterpiece, "), _c('i', [_vm._v("The Half Has Never Been Told: Slavery and the Making of American Capitalism")]), _vm._v(", we learn through well-documented accounts of that time that America’s economic supremacy was built almost entirely on the backs of those who were enslaved. Summarizing the reasons behind the apparent contradiction, Baptist offers the following explanation:")])]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("All these assumptions lead to still more implications, ones that shape attitudes, identities, and debates about policy. If slavery was outside of US history, for instance—if indeed it was a drag and not a rocket booster to American economic growth—then slavery was not implicated in US growth, success, power, and wealth. Therefore, none of the massive quantities of wealth and treasure piled by that economic growth is owed to African Americans. Ideas about slavery’s history determine the ways in which Americans hope to resolve the long contradiction between the claims of the United States to be a nation of freedom and opportunity, on the one hand, and, on the other, the unfreedom, the unequal treatment, and the opportunity denied that for most of American history have been the reality faced by people of African descent."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-019",
      "id": "ap_ntf-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The degree to which slavery contributed to the superiority of the US economy is only one of many areas in which history has been skewed, forgotten, or replaced with fiction. "), _c('i', [_vm._v("Lies My Teacher Told Me: Everything Your American History Textbook Got Wrong")]), _vm._v(", by James W. Loewen, explores further harmful discrepancies, many of them less about ignoring the harm done and more about forgetting the major roles people of color played in bringing about the modern society we enjoy today.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "role": "doc-pagebreak",
      "title": "32"
    }
  }, [_vm._v("Loewen shows how reading modern textbooks would lead anyone to believe that only the White people of the Western world, for instance, should be credited with our understanding of world geography and the peoples that exist within it. But a careful study of those peoples paints a different picture. Loewen writes:")])]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("So long as our textbooks hide from us the roles that people of color have played in exploration, from at least 6000 BC to the twentieth century, they encourage us to look to Europe and its extensions as the seat of all knowledge and intelligence. So long as they say “discover,” they imply that whites are the only people who really matter. So long as they simply celebrate Columbus, rather than teach both sides of his exploit, they encourage us to identify with White Western exploitation rather than study it."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-020",
      "id": "ap_ntf-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There was a time when all this information was news to me. Yes, I understood as a teenager that there were bleak points in America’s history. But from the textbooks we read throughout my K–12 experience, those were just moments in time, limited to certain areas of the Deep South. The enslavement of Africans and Black oppression was despicable, but I was educated to believe that we had moved past that time. In fact, I recall one White US History teacher in high school telling me in front of an all-Black classroom that "), _c('i', [_vm._v("“the mistakes of the past had no weight for Black people today.”")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("However, a conversation with my grandfather changed all that.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_vm._v("MY GRANDFATHER’S WORDS")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When I was seventeen, I bought a 1981 Chevrolet Caprice from one of my best friends and his dad, who was a father figure to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "role": "doc-pagebreak",
      "title": "33"
    }
  }, [_vm._v("me. My friend’s name is Atif Shaw, and his dad, Artie, was a positive role model in my teenage years. Back then, the only thing I put more effort into than getting into trouble was saving up to buy that car. It was beautiful, with a baby blue and white top exterior and a navy blue interior. Like any used car, it had issues: the right window wouldn’t roll down, sometimes the air conditioner wouldn’t work, and there was no heat in the winter. I had to wait for the warmth of the motor to make its way through the vents just to defrost the windows. But I loved that car. It looked great, and it got me around most of the time—until it didn’t.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Have you ever had that experience where you go to press the brake pedal but the car doesn’t slow down? That was me one hot afternoon in July. I was coming back from playing basketball at the park and preparing to come to a stop, but my car had other intentions. With all the power I could muster, I pressed down hard on the brake pedal, finally grinding it to a halt. The brake booster had gone out.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I had only owned the car for seven months, and I was already having problems. Not a good sign. Soon I began contacting mechanics in my area. But each quote I received left me more discouraged. There was no way I could afford what they would charge me.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Overhearing my conversations, Mom told me to call my grandfather.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Carlton York was a mechanic by trade and had every tool in his garage to prove it. Air compressors, socket sets, and car jacks were just a few of his many tools that I knew nothing about. I had never touched a socket wrench before in my life and had no intention of breaking this pattern in the foreseeable future. But Granddaddy had other plans. After I gave him a call about the car, he told me to drive it over, and he would show me how to fix it. I didn’t like the sound of that.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "role": "doc-pagebreak",
      "title": "34"
    }
  }, [_vm._v("Easing the shiny Caprice into his driveway, I noticed he was primed and ready to go. There was no chitchat and no “great to see you, Terence.” Instead, like a character out of a movie, my granddad strapped a flashlight on his head and slid under the car, motioning for me to do the same. It was as if he had been waiting for this moment my entire life.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Before I finished shimmying into position, my granddad handed me a socket and began motioning toward different parts above me.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Okay, so first, you loosen that bolt, then that one, and don’t forget that one over there. Then you pop this thing out. But be careful you don’t bang your head in the process.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I cursed inside. This was not the sort of hands-on lesson I had in mind when I said I needed help.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mustering what little willpower I had, I set to work. My progress was slow, and I realized that unscrewing a tight bolt in an awkward position was no simple task. After dropping the socket for the fifth time, my silent frustration boiled over.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can’t do it,” I muttered, not expecting the reaction those four words would generate.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Granddaddy’s jaw tightened, and from his dark expression you would have thought I had spat in his face and called him a liar.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Terence, I don’t ever want to hear that word come out of your mouth again. Where we come from, ‘can’ is how you survive.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I paused, unsure how to respond and unaware of how those next few hours would change my life. As we lay under the front of my car with our backs caked in dirt, I had one of the deepest conversations I had ever had with my grandfather.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He told me about growing up during a segregated era, how he went to an all-Black high school, drank out of “colored” water fountains, how if he had driven this car when he was my "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "role": "doc-pagebreak",
      "title": "35"
    }
  }, [_vm._v("age, the police would have stopped him every time he came or went. “Hell, they stopped me on my bike just to remind me they were in charge,” he told me. He reminded me it wasn’t that long ago that the police were formed in this country for the specific purpose of capturing escaped slaves. The NAACP has well-documented history of slave patrolling in America, which even includes a slave patrol oath in North Carolina.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The origins of modern-day policing can be traced back to the slave patrol. The earliest formal slave patrol was created in the Carolinas in the early 1700s with one mission: to establish a system of terror and squash slave uprisings with the capacity to pursue, apprehend, and return runaway slaves to their owners. Tactics included the use of excessive force to control and produce desired slave behavior. Patrollers signed an oath that read:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I [patroller’s name], do swear, that I will as searcher for guns, swords, and other weapons among the slaves in my district, faithfully, and as privately as I can, discharge the trust reposed in me as the law directs, to the best of my power. So help me, God.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Slave patrols continued until the end of the Civil War and the passage of the Thirteenth Amendment. Following the Civil War, during Reconstruction, slave patrols were replaced by militia-style groups who were empowered to control and deny freed slaves access to equal rights. They relentlessly and systematically enforced Black Codes, strict local and state laws that regulated and restricted access to labor, wages, voting rights, and general freedoms for formerly enslaved people."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-021",
      "id": "ap_ntf-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Granddaddy then told me about run-ins with the Ku Klux Klan. He described being chased for miles by a pickup truck before four men jumped out and beat him, forcing him to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "role": "doc-pagebreak",
      "title": "36"
    }
  }, [_vm._v("spend several days in a hospital. He told me stories about how he was almost lynched, and even writing this gives me chills.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Pausing this history lesson, he looked deep into my eyes and asked, “Have you been through anything like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No,” I replied, too ashamed to say anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s right,” he said, “because we went through it for you. You can’t have any fear, Terence. Now, take that socket and try again.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I did, and we finished the installation. By this point, my thoughts had shifted from the frustration of my broken-down car to the hardships Black people had experienced. Sure, I knew about some of these pains, but my knowledge had always come from a distance because of the lack of information in school. After this conversation, it was no longer buried. It was in my face and a part of me. Those brutal acts of racism I had heard occurred in the past and to people I did not know, but now they were part of my ancestry and thus part of my story.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Listening to my grandfather’s experiences changed everything. For the first time in my life, I felt his pain, but I also understood our collective pain as Black people. Those distant, horrific stories were now personal because they happened to someone I talked to, touched, and interacted with. Someone I loved. He was—and is—my living history, and as I write this book, he is still alive.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My grandfather’s words continue to echo in my mind to this very day. They came to mind in 2008 when the first Black man was elected president. “Yes, we can!” was more than a catchy campaign slogan for people like him who understood the long journey of oppression. For many Black people, including my grandfather, it symbolized the power of determination, resilience, and sacrifice. It symbolized moments of hope in the aftermath of collective pain. It was something that gave us hope of seeing the first biracial woman as vice president or the first "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "role": "doc-pagebreak",
      "title": "37"
    }
  }, [_vm._v("Black woman as a justice on the US Supreme Court—especially for women like my grandmother Gloria York, who would remind me of the mistreatment Black women experienced during enslavement and Jim Crow, and the mistreatment that still happens frequently in society today. It represented small changes from the past but also spoke to the history we must still unearth so those who are blinded to it can grapple with its realness and lingering effects.")])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_vm._v("MY JOURNEY INTO THE PAST")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("After hearing what my grandfather had lived through, I went on my own personal journey to better understand the history of my people. Because of the lack of information I’d received in school, I assumed there would be few books on this subject. But I couldn’t have been more wrong. There were scores of titles detailing the historical struggles of Black people in society, and still more showing the link between that history and the persistent challenges of today, all written by Black people. I often wondered why these titles and authors were never spoken about in depth during school. Whether "), _c('i', [_vm._v("Invisible Man")]), _vm._v(" by Ralph Ellison, "), _c('i', [_vm._v("Another Country ")]), _vm._v("by James Baldwin, Zora Neale Hurston’s "), _c('i', [_vm._v("Mules and Men")]), _vm._v(", or "), _c('i', [_vm._v("Song of Solomon")]), _vm._v(" by Toni Morrison, each of these titles and more shaped my understanding of the struggle of Black people to gain equality.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In a recent book by Isabel Wilkerson, "), _c('i', [_vm._v("Caste: The Origins of Our Discontents")]), _vm._v(", we’re shown how society has always slotted Black people into a caste, one that is looked down on as well as deprived of critical advantages. She compares caste systems around the world to the American class system that was built on White supremacy. The book highlights the fact that while caste systems have been around for thousands of years and are not always based on race, in America, being Black immediately identifies one as a member of this lower strata.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "role": "doc-pagebreak",
      "title": "38"
    }
  }, [_vm._v("In an interview with NPR, Wilkerson explains that")])]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("caste focuses in on the infrastructure of our divisions and the rankings, whereas race is the metric that’s used to determine one’s place in that. Caste is the term that is more precise [than race]; it is more comprehensive, and it gets at the underlying infrastructure that often we cannot see, but that is there undergirding much of the inequality and injustices and disparities that we live with in this country.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This is history, but as Wilkerson painstakingly shows, it is also the Black condition here and now.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The more I looked around and developed my personal library of stories and history that centered my ancestors—both those who came before me (during enslavement) and those living in contemporary times who have recently passed away—the more I found. And the more I found, the more I understood why so much was being left out. Many years after my talk with Granddaddy, I was invited to preach in a fairly large, predominantly White church working intently on racial justice and healing. That my granddaddy agreed to come and listen was an accomplishment in itself. He’d never witnessed a Black person speaking to a largely White congregation, and, knowing he wouldn’t be around forever, I asked if he wanted to come with my grandmother and hear me, and he agreed. After the service, he told me how scared he had felt the entire time. He was afraid that at any moment I might say something wrong, and that the congregation would turn on me. I could hear the trauma from White supremacy and racism coming through his words, and it broke my heart. Does it break yours?")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When he was young, a situation like this would have caused him to fear for his life based on his encounters with the KKK. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "role": "doc-pagebreak",
      "title": "39"
    }
  }, [_vm._v("This was hard for me to comprehend, but I could understand it somewhat, based on how racism still shows up today.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Imagine someone you care for and respect as a pillar of your life. Now picture that individual having to battle fear, not because they might have cancer or lose their job (things that most of us would agree are beyond our control), but because of real-life experiences and trauma stemming from the hands of other people filled with racial hatred.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What if it wasn’t just your grandfather or grandmother, but also your parents and your aunts and uncles and your friends’ parents and grandparents? What if the list went on and on until almost everyone you knew of a certain age had their own stories of how people of a particular segment of society had mistreated them? What if you saw it with your own eyes too? How would that make you feel?")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I can tell you how I felt: angry, scared, confused, and upset that so much history had been buried. I realized my grandfather never got a chance to occupy White spaces without fear of something being done to him, let alone hearing his Black grandson preach to this audience as they listened. Many Black persons still fear harm in White spaces to this day.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I also understood that if some of the persons sitting in the congregation could have heard his story, even if they were not convinced that structural, systemic racism still exists, they would listen because these were his lived experiences, and you can’t refute or argue against an actual lived experience. And maybe if they listened, he could have expressed some of what he suffered, which he has never been able to share with a White person. Still, I couldn’t say I blamed him for feeling fearful because, as I stated earlier, I have been in some White spaces that were very harmful. But that’s what a story does. It takes a person, little more than a caricature or an idea, and turns it into a human being.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "role": "doc-pagebreak",
      "title": "40"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_vm._v("THOSE BRAVE FEW")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Stories have always been important to people of color. For many years, stories of the past were recited orally. I learned from my grandfather that slave masters used to cut the tongues out of the mouths of those who were enslaved if they posed a threat to organize or speak against harsh treatment, pass along stories, or attempt to read. To know that the tongues of those who were enslaved were cut out for trying to speak up or pass along these important narratives gave me a deeper perspective on why it is important to unearth buried history and include all God’s children. Little was documented in writing, causing future generations of people of color to misunderstand their own history.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Fortunately, in every era, there have been a few brave souls who set down their fears and prejudices and waded into the turbulent waters of society to try to calm them. On February 27, 1926, Carter G. Woodson initiated the first sustained effort to expand the study of and scholarship on African American history. It was called Negro History Week. According to the history documented by the NAACP, Woodson faced numerous obstacles after his birth in 1875. His parents were former slaves and illiterate, and he was only able to attend school sporadically. He spent his childhood and teen years working on the family farm and in the West Virginia coal mines. Yet Woodson was eager to learn, and he educated himself on the basic subjects before entering high school at twenty years old. He graduated in less than two years and later became a prominent historian, authoring several books on Black Americans."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-022",
      "id": "ap_ntf-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Woodson believed that the historical contributions of Black people had been “overlooked, ignored, and even suppressed by the writers of history textbooks and the teachers who use them.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-023",
      "id": "ap_ntf-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "role": "doc-pagebreak",
      "title": "41"
    }
  }, [_vm._v("Woodson launched Negro History Week in February to coincide with the birthdays of both Frederick Douglass and Abraham Lincoln. At a time when Black people weren’t allowed to use the same bathrooms or sit in the same places on the bus as White people, Woodson felt passionately that the history, heritage, and contributions of Black people should not be lost to posterity.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Before Woodson’s efforts, there had been next to nothing, aside from oral histories, available to Black people, or anyone else, to help them understand the true history of Black folks. His Negro History Week later became what we now know as Black History Month, and it has inspired people to learn and teach about Black history year-round. Since 1926, that knowledge has been inscribed in volume after volume. Woodson’s legacy has been immeasurable because it is something that Black people have taken pride in 365 days of the year, not just one month. And yet, within our primary learning institutions and even within a large portion of our churches and Bible colleges, this important history is being softened, glazed over, or outright ignored.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In the modern context, I understand how difficult it is for many people who are a part of a majority culture to connect with the full extent of Black history because they do not want to feel responsible for its suppression or oppression. However, it is important to understand how society has been established in a way that elevates the history of White culture and buries and devalues the history of people of color. The racism of today is not so obvious, not so intentional, not so frequent, and not so immersive as it was just a few generations ago. However, that does not mean it is not alive and that we should not call it out every time we see examples of it harming people. In so many ways, it has been inherited without knowledge. Our textbooks teach it. Our churches even contribute to it, perpetuating the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "role": "doc-pagebreak",
      "title": "42"
    }
  }, [_vm._v("fictional image of a pale, White, blue-eyed Jesus. So why, in the times we live in now, when every bit of information we could ever want is at our fingertips, do we still teach and exhibit such obvious and prevailing untruths?")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I’m sure I don’t know all the reasons, but I do know this: guilt hurts and, most important, the truth hurts. But we cannot heal or stand in solidarity with one another by ignoring these truths. And for those who look across the divide and see the struggles of Black and Brown people in this country and wish they could change a past created by White supremacy, I can’t imagine what that must feel like. How tempting must it be to pretend that history never happened or to construct and perpetuate the least painful version of events—which is a part of what it means to create a harmful revisionist history. But we must resist that urge because, as Christina Barland Edmondson notes, “disrupting systems of racial injustice is first and foremost a heart issue.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-024",
      "id": "ap_ntf-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Instead, if you have been raised in an all-White community or a community that is not Black, it might be helpful to reflect on a few questions. Ask yourself these questions:")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("How was Black history taught in my classes?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What role did Black leaders play in shaping history?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Did my school teach that it was only European influencers who shaped the economic prosperity we enjoy today?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Why was Black history not taught in full?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Why is there so much White backlash when people of color speak about their history to inform the present moment?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Why did George Floyd’s death spark nationwide and worldwide protests?")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Asking these tough questions can be difficult, but they lead us down the path of understanding.")])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "role": "doc-pagebreak",
      "title": "43"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_vm._v("EVERYONE HAS A HISTORY")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Every time we attempt to distort or alter history, we discredit the effects it has on us. Whitewashing the past only creates an environment for history to repeat itself.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I have a history. You have a history. Every person was given some version of the Talk. For White people, sometimes the Talk is less about what is said and more about what is implied, modeled, or allowed. Maybe Black friends were not allowed; Black churches were something to avoid, and the brown-skinned Jesus was replaced with a pale-faced Savior with blond hair and blue eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I grew up in an all-Black neighborhood, so I did not have any White friends growing up, and that had a tremendous impact on how I saw myself in the world, especially learning how White people saw Black America through the news and what information was avoided in school. And I imagine if people grew up only around others from the same location, it would dramatically shape the way they viewed the world. The Talk isn’t just a speech but includes how we have seen those around us live out their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Only a few years before my grandfather was born, D. W. Griffith’s "), _c('i', [_vm._v("Birth of a Nation")]), _vm._v(" debuted on the silver screen. It was the first movie that held racism at its core that was played in the White House. This was the first time blackface had been used in a motion picture, and the film portrayed Black people as inferior creatures, barely above beasts. That kind of visual rhetoric assigned to an entire segment of society was damaging, not only for that era’s Black people but for the generations that were raised by the people who bore that pain. Imagery is powerful because it perpetuates harmful narratives. It made it that much harder for Black men and women to be viewed as equals, on top of what the enslavement period did. The Bible tells us that we are God’s creation and God’s special "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "role": "doc-pagebreak",
      "title": "44"
    }
  }, [_vm._v("workmanship. We are all God’s children, and it is important for us to understand the worth and value of each person and their historical shaping.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Everyone has a past to unpack and understand. What is your history? What conversations did you have as a child that shaped the way you think today about race? How did you see BIPOC groups treated in your community? What writers, speakers, and political leaders influence your thinking? What is the lens through which you view society"), _c('i', [_vm._v("? ")]), _vm._v("All these factors play a role in shaping how you view the world and those you wish to stand in solidarity with.")]), _vm._v(" "), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-001"
    }
  }, [_c('h2', {
    staticClass: "enc_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("APPLICATION")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("If you are pondering any of my words in depth, here is my challenge to you as we embark on the rest of these chapters. I challenge you to do some deep introspection as to what version of the Talk you heard growing up, whether in words or deeds, and sit with those memories. Sit with them against the backdrop of truths you may be unearthing from hearing parts of history that might have been kept from you. Before you do anything, you must first evaluate the history you’ve been taught, whether consciously or subconsciously, and how it has impacted the way you see others.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When you see a Black person or a person of color, ask yourself a few questions:")]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Do I have an automatic response?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Am I afraid or disgusted, or do I feel guilty?")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Do I smile a little wider, trying to show the other person I “don’t see color”?")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ask yourself, "), _c('i', [_vm._v("Where does this framing come from?")]), _vm._v(" The answer might be obvious, or it might not. You might have to search for it deep within yourself or within your past, but finding it is the first step toward understanding. Before I understood my grandfather’s "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45",
      "role": "doc-pagebreak",
      "title": "45"
    }
  }, [_vm._v("past, I did not see my own world clearly. But when I entered his world, which is connected to the history of my ancestors, my world opened up. When we choose to discover the history of another person or explore our own historical shaping, we can truly see the people standing right before our eyes, and thus understand our own shaping—and that honors God.")])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 72
// module chunks = 0